import * as React from 'react'
import { connect } from 'react-redux'

import * as actions from 'common/actions'
import { ConfigKeys, Filter, Filters, Product } from 'even-ts-static'

import { CreditFilter } from './index'
import { MultiProductState } from 'embed/reducers'

interface DispatchProps {
  dispatchFetchCreditCardOffers: () => void
  dispatchFilterChanged: (filter: Filter, value, userInitiated: boolean) => void
  dispatchNonApplicationFiltersChanged: (filter: Filter, value, userInitiated: boolean) => void
}

interface StoreProps {
  filters: Filters
  resultsUuid?: string
}

export type CreditFilterProps = DispatchProps & StoreProps

const CreditFilterContainer: React.FC<CreditFilterProps> = ({
  dispatchNonApplicationFiltersChanged,
  dispatchFilterChanged,
  dispatchFetchCreditCardOffers,
  filters,
  resultsUuid,
}) => {
  React.useEffect(() => {
    // Load initial results (if a result uuid was not specified in the config)
    if (resultsUuid === undefined) {
      dispatchFetchCreditCardOffers()
    }
  }, [resultsUuid, dispatchFetchCreditCardOffers])

  const onChange = React.useCallback(
    (filter: Filter, value) => {
      if (filter === Filter.CreditScore) {
        dispatchNonApplicationFiltersChanged(filter, value, true)
      } else {
        dispatchFilterChanged(filter, value, true)
      }

      // Don't fetch if the issuer changes since it's just client filtering
      dispatchFetchCreditCardOffers()
    },
    [dispatchNonApplicationFiltersChanged, dispatchFilterChanged, dispatchFetchCreditCardOffers],
  )

  return <CreditFilter filters={filters} onChange={onChange} />
}

const mapStateToProps = (state: MultiProductState): StoreProps => ({
  filters: state.filters[Product.CreditCard] ?? {},
  resultsUuid: state.config[ConfigKeys.ResultsUuid],
})

const mapDispatchToProps = (dispatch) => ({
  dispatchFetchCreditCardOffers: () => dispatch(actions.fetchCreditCardOffers()),
  dispatchFilterChanged: (filter, value, userInitiated) =>
    dispatch(actions.filterChanged(Product.CreditCard, filter, value, { userInitiated })),
  dispatchNonApplicationFiltersChanged: (filter, value, userInitiated) =>
    dispatch(actions.nonApplicationFiltersChanged(Product.CreditCard, filter, value, { userInitiated })),
})

export const ConnectedCreditFilterContainer = connect<StoreProps, DispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(CreditFilterContainer)
